import React from 'react';
import ReactDOM from 'react-dom';
import Tunnel from './containers/Tunnel';

// Render the tunnel component wherever #tunnel-container is defined
if (document.getElementById('tunnel-container')) {
  ReactDOM.render(
    <Tunnel />,
    document.getElementById('tunnel-container')
  );
}
